/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const SET_CHECKOUT_FEATURE_FLAG = 'MBP-PWA-UI/SET/CHECKOUT/FEATURE/FLAG';

export default {};
